// extracted by mini-css-extract-plugin
export const Footer = "Footer-module--Footer--1IeE-";